export const iconFontAwesomeShoppingMoneyCheckDollar = (
	<i className="fa-solid fa-money-check-dollar"></i>
);
